import { useContext } from 'react'

// Context
import { InventoryDataContext } from 'src/store/inventory/Store'

import Bar from './Bar'
import { ItemDataContext } from 'src/store/items/Store'
import { StatsDataContext } from 'src/store/stats/Store'

const CarryCapacity = () => {
  const { inventory } = useContext(InventoryDataContext)
  const { stats } = useContext(StatsDataContext)
  const { items } = useContext(ItemDataContext)
  const bagItemsWeight = Object.entries(inventory.bag).reduce((total, [itemID, quantity]) => (total + (quantity * items[itemID].weight || 0)), 0)
  const equippedWeight = Object.entries(inventory.equipped).reduce((total, [_, itemID]) => (total + (items[itemID] && items[itemID].weight ? items[itemID].weight : 0)), 0)
  const weight = (bagItemsWeight + equippedWeight)
  const maxWeight = stats.total.kg_max
  return <Bar currentValue={weight} maximumValue={maxWeight} label='kg' color={ weight >= maxWeight ? 'crimson' : weight >= maxWeight / 2 ? 'gold' : 'white'} className="carry-capacity"/>
}

export default CarryCapacity
